import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useHostfullyAccounting from 'hooks/hostfullyAccounting/useHostfullyAccounting';
import useNotify from 'hooks/useNotify';
import { HOSTFULLY_ACCOUNTING_PATH } from 'pages/hostfullyAccounting/hostfullyAccounting.constants';
import { redirectToIntegrationAccessUrl } from 'utils/integrations/integrationAccessUrl';

const useHostfullyAccountingRedirect = () => {
  const { t } = useTranslation();
  const { notifyError } = useNotify();
  const navigate = useNavigate();
  const accounting = useHostfullyAccounting();

  const redirectToHostfullyAccounting = () =>
    redirectToIntegrationAccessUrl({
      fetchAccessUrl: accounting.fetchAccountingAccess,
      onAccessPending: () => navigate(HOSTFULLY_ACCOUNTING_PATH),
      onAccessError: () =>
        notifyError(t('common.hostfullyAccountingAccessError')),
    });

  return { ...accounting, redirectToHostfullyAccounting };
};

export default useHostfullyAccountingRedirect;
